
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ItemChip from "@/components/common/ItemChip.vue"

  import RouteNames from "@/entities/RouteNames";
  import GroupChipData from "@/entities/GroupChipData";

  @Component({
    components: {
      ItemChip,
    },
  })
  export default class GroupChips extends Vue {
    @Prop({ type: Array, required: true }) readonly groups!: GroupChipData[];
    @Prop({ type: Number, default: 1 }) readonly limit!: number;
    @Prop({ type: Object, default: () => ({}) }) readonly navigateTo!: object;

    routeNames = RouteNames;

    get noContent(): boolean {
      return !this.groups.length;
    }

    get groupsToRender(): GroupChipData[] {
      return this.groups.slice(0, this.limit);
    }

    get groupsMoreThanLimit(): boolean {
      return this.groups.length > this.limit;
    }

    get alignmentClass(): string {
      return this.noContent ? "items-end mt-0.5" : "items-center";
    }

    isContractorsExist(conractorsCount: number): boolean {
      return conractorsCount > 0;
    }
  }
